import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { NextStep } from "../Types/ListeningReportTypes";
import { REPORT_KEY, ReportBadge, ReportTag, SectionTitle } from "./ReportPrimitives";

const NextStepsSection: FC<{ steps: NextStep[] }> = ({ steps }) => {
  const { t } = useTranslation();

  return (
    <section className="br__panel" id="br-actions" data-pdf-block="br-actions" data-pdf-splittable aria-label={t(`${REPORT_KEY}.tabs.actions`, "Next Steps")}>
      <SectionTitle>{t(`${REPORT_KEY}.nextSteps.title`, "Strategic Next Steps")}</SectionTitle>
      <div className="br__grid">
        {steps.map(step => (
          <div className="br__card br__step br__c4" key={`${step.priority}-${step.title}`}>
            <div className="br__step-top">
              <ReportBadge tone="blue">{step.priority}</ReportBadge>
              {step.effort && (
                <span className={`br__effort br__effort--${step.effort.level}`}>{step.effort.label}</span>
              )}
            </div>
            <h3>{step.title}</h3>
            <p>{step.body}</p>
            <div className="br__step-tags">
              {step.tags.map(tag => (
                <ReportTag key={tag} small tone="blue">
                  {tag}
                </ReportTag>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default NextStepsSection;
